import React from "react";
import { connect } from "react-redux";
import { Button } from "../Button";
import { getStorage } from "../../utils/storage";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class ChangePassword extends React.Component {
  state = {
    isLoading: false,
    linkSent: false,
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  handleSendResetLink = async () => {
    const { user } = this.state;
    const email = user.email;

    if (!email) {
      toastMessage("error", "No email address found for your account.");
      return;
    }

    try {
      this.setState({ isLoading: true });

      const isDonor = user.role === "donor" || user.account_type === "donor";
      const endpoint = isDonor
        ? `${API_URL}/donor/requestpasswordreset`
        : `${API_URL}/account/requestpasswordreset`;

      const { data } = await axios.post(endpoint, { email });

      if (data.status === "error") {
        toastMessage("error", data.message);
      } else {
        this.setState({ linkSent: true });
        toastMessage("success", data.message);
      }
    } catch (error) {
      toastMessage("error", error?.response?.data?.error || error.message);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { linkSent, isLoading, user } = this.state;

    return (
      <div className="row">
        <div className="col-md-4">
          {!linkSent ? (
            <>
              <p>
                A password reset link will be sent to{" "}
                <strong>{user.email}</strong>. Click the link in the email to
                set a new password.
              </p>
              <Button
                text="Send Reset Link"
                isLoading={isLoading}
                onPress={this.handleSendResetLink}
              />
            </>
          ) : (
            <div>
              <p style={{ color: "green", fontWeight: "bold" }}>
                Reset link sent to <strong>{user.email}</strong>
              </p>
              <p>
                Check your inbox and click the link to set your new password. If
                you don't see it, check your spam folder.
              </p>
              <Button
                text="Resend Link"
                className="btn-outline"
                isLoading={isLoading}
                onPress={() => {
                  this.setState({ linkSent: false });
                  this.handleSendResetLink();
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ChangePassword);
